import Vue from 'vue'
import VueScreenSize from 'vue-screen-size'

Vue.use(VueScreenSize)

export default {}
